export const getEnvironmentTitle = () => {
	const hostname = window?.location?.hostname || '';
	if (hostname.includes('verkauf-test')) {
		return 'Testumgebung';
	}
	if (hostname.includes('verkauf-training')) {
		return 'Trainingsumgebung';
	}
	if (hostname.includes('localhost')) {
		return 'Development';
	}

	return null;
};
